<template>
  
  <div class="scroll-progress">
    <ul>
      <template v-for="{name,id,visible,depth,show} in items">
      <li v-if="show" :key="id" class="item" :class="
        [
          {
            visible: visible,
            parent: visible > 1,
          },
          'depth-'+depth
        ]
      " @click="scrollTo(id)">
        {{ name }}
      </li>
      </template>
    </ul>
  </div>

</template>
<script>
export default {
  name: "scroll-progress",
  data() {
    return {
      scroll_tracker: null,
    };
  },
  props: {
    scrollOffset: {
      type: [Number,String],
      default: 0,
    },
  },
  methods: {
    scrollTo(id){
      this.$scrollTo('#' + id, {offset: parseFloat(this.scrollOffset), container: ".scroll-area"});
    },
  },
  computed: {
    items(){
      return this.scroll_tracker ? this.scroll_tracker.sections : [];
    },
  },
  mounted(){
    let scroll_tracker = this;
    while(scroll_tracker && scroll_tracker.$options.name != 'scroll-tracker'){
      scroll_tracker = scroll_tracker.$parent;
    }
    if(scroll_tracker){
      this.scroll_tracker = scroll_tracker;
    }else{
      console.error('ScrollProgress unable to find ScrollTracker parent', this);
    }
  },
};
</script>
<style scoped lang="scss">
  @import "../../assets/scss/theme.scss";

  .scroll-progress{
    top: 15px;
    border-left: 2px solid #B8B8B8;

    & ul{
      padding: 0px;
    }

  }

  .item{
    cursor: pointer;
    padding: 3px 15px;
    margin-top: 5px;
    margin-left: -2px;

    list-style-type: none;
    border-left: 2px solid  #B8B8B8;

    transition: border 0.2s, color 0.2s;

    color: $color-text-light;

    &.visible{

      color: $color-primary;
      font-weight: bold;
      
      border-left-color: $color-primary;

      &.parent{
        font-weight: normal;
        color: $color-text-light;
      }

    }

    &.depth-0{
      padding-left: 10px;
    }

    &.depth-1{
      padding-left: 25px;
    }

    &.depth-2{
      padding-left: 40px;
    }

    &.depth-4{
      padding-left: 55px;
    }

    &.depth-5{
      padding-left: 70px;
    }

  }
</style>
